"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Landing = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Landing = () => {
    return (0, jsx_runtime_1.jsx)("div", { children: "Ecommerce!" });
};
exports.Landing = Landing;
//# sourceMappingURL=index.js.map